const orderPairs = [
  // crypto
  'BTCUSDT',
  'ETHUSDT',
  'XRPUSDT',
  'BNBUSDT',
  'SOLUSDT',
  'DOGEUSDT',
  'ADAUSDT',
  'LINKUSDT',
  'BCHUSDT',
  'LTCUSDT',
  'EOSUSDT',
  // virtual
  'BFULLL',
  'LALLLL',
  'MLMLLL',
  'WKWLLL',
  'G100',
  '5YR',
  '10YR',
  'BMSTM',
  'CRDM',
  'KNBW',
];

export default function(pairs) {
  let otherPairs = [];

  const sortPairs = pairs.length
    ? pairs.filter(p => orderPairs.indexOf(p.name) >= 0).sort(function(a, b) {
      return orderPairs.indexOf(a.name) - orderPairs.indexOf(b.name);
    })
    : [];

  if (sortPairs.length !== pairs.length) {
    otherPairs = pairs.filter(p => orderPairs.indexOf(p.name) < 0);
  }

  return [...sortPairs, ...otherPairs];
}
